import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const CompleteButton = ({ onClick, disabled }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main success-button'} onClick={onClick} disabled={disabled}>
            {t('common:buttons.complete')}
        </button>
    );
};